// src/i18n/index.js
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";

const dictionaries = { fr, en };

// Pas de sélecteur pour l'instant : on force la langue ici.
export const LANG = "en";

export function t(key, vars) {
  let str = dictionaries[LANG]?.[key] ?? fr[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      str = str.replaceAll(`{${k}}`, v);
    }
  }
  return str;
}
